import { useStores } from "@/stores/useStores";

/** Access the project message board store. */
export function useMessagesStore() {
  return useStores().messagesStore;
}
